// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__Ta39z","title":"style_title__LdRCd","icon":"style_icon__BvCrs","isBpSmall":"style_isBpSmall__qEcEN"};